(function () {
  function readJsonScript(id) {
    var el = document.getElementById(id);
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return {};
    }
  }

  function escapeRegex(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function isValidEmail(email) {
    if (!email) return false;
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email).trim());
  }

  function trackGtag(payload) {
    if (typeof window.gtag !== 'function') return;
    try {
      window.gtag('event', payload.eventAction, {
        event_category: payload.eventCategory,
        event_label: payload.eventLabel,
      });
    } catch (e) {}
  }

  function cancelOrder(config, orderName, customerEmail) {
    var url = window.location.origin + (config.endpoint || '');
    var body = new URLSearchParams();
    body.append('shop_domain', config.shopifyDomain);
    if (orderName) body.append('shopify_order_name', String(orderName).trim());
    body.append('customer_email', String(customerEmail).trim());

    return fetch(url, {
      method: 'POST',
      headers: {
        Authorization: config.cancelToken || '',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: body.toString(),
      redirect: 'follow',
    });
  }

  function initForm() {
    var form = document.querySelector('.js-am-cancellation__form');
    if (!form) return;

    var config = readJsonScript('AMCancellationConfig');
    var els = {
      validationContainer: form.querySelector('.js-am-cancellation__validation'),
      emailEmpty: form.querySelector('.js-am-cancellation__email-empty'),
      emailFormat: form.querySelector('.js-am-cancellation__email-format'),
      orderEmpty: form.querySelector('.js-am-cancellation__order-empty'),
      orderFormat: form.querySelector('.js-am-cancellation__order-format'),
      success: form.querySelector('.js-am-cancellation__success'),
      err404: form.querySelector('.js-am-cancellation__err-404'),
      err422: form.querySelector('.js-am-cancellation__err-422'),
      submit: form.querySelector('.js-am-cancellation__submit'),
    };

    var loading = false;

    function hide(el) {
      if (el) el.hidden = true;
    }
    function show(el) {
      if (el) el.hidden = false;
    }

    function resetErrors() {
      hide(els.validationContainer);
      hide(els.emailEmpty);
      hide(els.emailFormat);
      hide(els.orderEmpty);
      hide(els.orderFormat);
      hide(els.success);
      hide(els.err404);
      hide(els.err422);
    }

    function setLoading(on) {
      loading = on;
      if (els.submit) {
        els.submit.disabled = on;
        els.submit.setAttribute('aria-busy', on ? 'true' : 'false');
        els.submit.classList.toggle('am-cancellation__submit--loading', on);
      }
    }

    function validateForm(orderName, customerEmail) {
      resetErrors();
      var ok = true;
      orderName = String(orderName || '').trim();
      customerEmail = String(customerEmail || '').trim();

      if (!orderName) {
        show(els.orderEmpty);
        ok = false;
      } else if (config.orderPrefix) {
        var re = new RegExp('^' + escapeRegex(config.orderPrefix));
        if (!re.test(orderName)) {
          show(els.orderFormat);
          ok = false;
        }
      }

      if (!customerEmail) {
        show(els.emailEmpty);
        ok = false;
      } else if (!isValidEmail(customerEmail)) {
        show(els.emailFormat);
        ok = false;
      }

      if (!ok) show(els.validationContainer);
      return ok;
    }

    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      if (loading) return;

      var fd = new FormData(form);
      var orderName = fd.get('shopify_order_name');
      var customerEmail = fd.get('customer_email');

      if (!validateForm(orderName, customerEmail)) return;

      if (!config.cancelToken) {
        show(els.validationContainer);
        show(els.err404);
        return;
      }

      setLoading(true);
      cancelOrder(config, orderName, customerEmail)
        .then(function (res) {
          resetErrors();
          if (res.status === 200) {
            show(els.success);
            trackGtag({
              eventCategory: 'Account',
              eventAction: 'Order Cancellation Success',
              eventLabel: 'Order Cancellation',
            });
          } else {
            show(els.validationContainer);
            if (res.status === 422) show(els.err422);
            else show(els.err404);
            trackGtag({
              eventCategory: 'Account',
              eventAction: 'Order Cancellation Fail',
              eventLabel: 'Order Cancellation',
            });
          }
          setLoading(false);
        })
        .catch(function () {
          resetErrors();
          show(els.validationContainer);
          show(els.err404);
          setLoading(false);
          trackGtag({
            eventCategory: 'Account',
            eventAction: 'Order Cancellation Fail',
            eventLabel: 'Order Cancellation',
          });
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initForm);
  } else {
    initForm();
  }
})();
